import { render } from "./TheAccessToken.vue?vue&type=template&id=27963d69"
import script from "./TheAccessToken.vue?vue&type=script&lang=js"
export * from "./TheAccessToken.vue?vue&type=script&lang=js"
script.render = render

export default script